import { MatDialog, MatDialogRef } from 'node_modules/@angular/material';
import { TemplateRef } from '@angular/core';
import { UserService } from './../../services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import * as NotificationActions from '../../reducers/actions/notification.actions';
var SolicitudesExpComponent = /** @class */ (function () {
    function SolicitudesExpComponent(_userService, dialog, spinner, store) {
        var _this = this;
        this._userService = _userService;
        this.dialog = dialog;
        this.spinner = spinner;
        this.store = store;
        this.cargado = false;
        this.getSolicitudes();
        this.store.select('contador').subscribe(function (response) {
            _this.contador_notification = response.contador;
        }, function (error) {
            console.log(error);
        });
    }
    SolicitudesExpComponent.prototype.getSolicitudes = function () {
        var _this = this;
        this.spinner.show();
        this._userService.getSolicitudes().subscribe(function (response) {
            console.table(response);
            _this.spinner.hide();
            _this.cargado = true;
            _this.solicitudes = response;
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    SolicitudesExpComponent.prototype.castEstado = function (estado) {
        switch (estado) {
            case 0: return 'Anulado';
            case 1: return 'Pre-Ingresado';
            case 2: return 'Ingresado';
            case 3: return 'Rechazado';
            default: return 'Anulado';
        }
    };
    SolicitudesExpComponent.prototype.openInfo = function (solicitud) {
        this.solicitud = solicitud;
        console.log(solicitud);
        if (solicitud.Estado == 3 && (solicitud.Notificado == "" || solicitud.Notificado == null || solicitud.Notificado == undefined)) {
            var cont;
            console.log("entre aqui en rechazado");
            if (this.contador_notification == 0) {
                cont = 0;
            }
            else {
                cont = this.contador_notification - 1;
            }
            this.store.dispatch(new NotificationActions.NotificationUpdate(cont));
            this.marcarSolicitud(solicitud);
            console.table(this.solicitud);
            if (solicitud.nota4 == "" || solicitud.nota4 == null || solicitud.nota4 == undefined) {
                swal({
                    type: 'info',
                    title: 'Respuesta a solicitud',
                    text: "\n                       <p>La solicitud a\u00FAn no recibe ninguna nota por parte del revisor</p>\n                        ",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                }).then(function () {
                });
            }
            else {
                swal({
                    type: 'info',
                    title: 'Respuesta a solicitud',
                    text: "\n                       <p>" + solicitud.nota4 + "</p>\n                        ",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                }).then(function () {
                });
            }
        }
        else {
            console.log("no rechazado");
            this.marcarSolicitud(solicitud);
            if (solicitud.nota4 == "" || solicitud.nota4 == null || solicitud.nota4 == undefined) {
                swal({
                    type: 'info',
                    title: 'Respuesta a solicitud',
                    text: "\n                       <p>La solicitud a\u00FAn no recibe ninguna nota por parte del revisor</p>\n                        ",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                }).then(function () {
                });
            }
            else {
                swal({
                    type: 'info',
                    title: 'Respuesta a solicitud',
                    text: "\n                       <p>" + solicitud.nota4 + "</p>\n                        ",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                }).then(function () {
                });
            }
        }
    };
    SolicitudesExpComponent.prototype.marcarSolicitud = function (solicitud) {
        if (solicitud.nota4 === "") {
            console.log("nota 4 vacio");
        }
        else if (solicitud.Notificado) {
            console.log("Esta solicitud rechazada ya ha sido notificada");
        }
        else {
            this._userService.marcarSolicitud(solicitud).subscribe(function (response) {
                console.log(response);
            }, function (error) {
                console.log(error);
            });
        }
    };
    return SolicitudesExpComponent;
}());
export { SolicitudesExpComponent };
